import React from 'react';

import { IconRegularDelivery } from '@notino/react-styleguide-v20';

import { BenefitItemTitle } from './components/BenefitItemTitle';
import { IBenefitItem } from './model';
import { StyledDescription } from './styled';

export const IconColumn = () => <IconRegularDelivery color={'icon.highlight'} width="20px" height="20px" />;

export const BodyColumn = (benefit: IBenefitItem, getBenefitTitle: () => React.ReactNode) => () => (
  <BenefitItemTitle
    onClick={benefit.onClick}
    active={benefit.isActive}
    activationThreshold={benefit.activationThreshold}>
    {getBenefitTitle()}
  </BenefitItemTitle>
);

export const InfoColumn = (getBenefitBody: () => React.ReactNode) => () => (
  <StyledDescription>{getBenefitBody()}</StyledDescription>
);
